export default "__VITE_PUBLIC_ASSET__22df4cd3__"